<template>
	<div class="login-view-root register-view-root">

		<!--    <div class="body-div layout-centered bg-img" style="" :style="{backgroundImage: 'url(' + require('@/assets/img/bg/8.jpg') + ')'}">-->
		<div class="body-div layout-centered bg-img">

			<!--    <div class="layout-centered bg-img" style="background-image:url('@/assets/img/bg/4.jpg')">-->


			<!-- Main Content -->
			<!-- Main Content -->
			<main class="main-content">

				<div class="bg-white shadow-7 w-400 mw-100 p-5 m-3" @mouseup="clearFormValidationInternal">
					<h4 class="mb-2">Create Your Account</h4>

					<div class="row mx-0 mb-5">
						<div>Special access invitation</div>
						<div class="layout-spacer"/>
						<div v-if="stepNumber > 1">
							<a @click="stepNumber = 1">Back</a>
						</div>
<!---->
					</div>

					<div>


						<el-form :model="form"
								 :rules="rules"
								 ref="mainForm"
								 novalidate="novalidate"
								 @submit.native.prevent="submitForm()"
						>
							<el-form-item prop="fullName" class="form-group mb-4 pt-2">
								<input type="text" class="form-control" name="name" v-model="form.fullName"
									   placeholder="Your Full Name">
							</el-form-item>

							<el-form-item prop="email" class="form-group mb-4 pt-2">
								<input type="email" class="form-control" name="email" v-model="form.email"
									   placeholder="Email Address">
							</el-form-item>

							<el-form-item prop="password" class="form-group mb-4 pt-2">
								<input type="password" class="form-control" name="password" v-model="form.password"
									   placeholder="Password">
							</el-form-item>

							<el-form-item prop="passwordConfirm" class="form-group mb-5 pt-2">
								<input type="password" class="form-control" name="password-confirm"
									   v-model="form.passwordConfirm" placeholder="Password (confirm)">
							</el-form-item>

<!--							<el-form-item prop="isTermsChecked" class="form-group py-3">-->
<!--								<div class="custom-control custom-checkbox">-->
<!--									<input type="checkbox" class="custom-control-input" id="terms_box"-->
<!--										   v-model="form.isTermsChecked">-->
<!--									<label class="custom-control-label" for="terms_box">I agree to the <a class="ml-1"-->
<!--																										  href="terms.html"-->
<!--																										  target="_blank">terms-->
<!--										of service</a></label>-->
<!--								</div>-->
<!--							</el-form-item>-->

							<div class="form-group">
								<el-button class="w-100" type="primary" :loading="isProgressShowing"
										   @click="submitForm()">Sign up
								</el-button>
							</div>
						</el-form>
						<div v-if="errorMessage" class="text-danger pt-3">
							{{ errorMessage }}
						</div>


						<!--                <div class="divider">Or Register With</div>-->
						<!--                <div class="text-center">-->
						<!--                    <a class="btn btn-circle btn-sm btn-facebook mr-2" href="#"><i class="fa fa-facebook"></i></a>-->
						<!--                    <a class="btn btn-circle btn-sm btn-google mr-2" href="#"><i class="fa fa-google"></i></a>-->
						<!--                    <a class="btn btn-circle btn-sm btn-twitter" href="#"><i class="fa fa-twitter"></i></a>-->
						<!--                </div>-->

<!--						<hr class="w-30">-->

<!--						<p class="text-center text-muted small-2">Already a member?-->
<!--							<router-link :to="loginLink">Login here</router-link>-->
<!--						</p>-->
					</div>


<!--					<div v-else>-->

<!--						<div>-->
<!--							<div class="mb-4">-->
<!--								<div style="padding: 0 13px">-->

<!--									<h4 v-if="isSpecialTrial">Start your free 6-Month Trial of Qwoach Essentials-->
<!--										Monthly</h4>-->
<!--&lt;!&ndash;									<h4 v-else-if="isSpecialContributor">Start your special Life-Time Discount of Qwoach&ndash;&gt;-->
<!--&lt;!&ndash;										Contributor Monthly</h4>&ndash;&gt;-->
<!--									<h4 v-else>Join Qwoach Core Contributors community</h4>-->

<!--									<div v-if="isPaddleLoading" class="text-center my-5">-->
<!--										<i class="fontello icon-spin5 mr-1"/>Loading...-->
<!--									</div>-->
<!--									<div v-else class="card p-2 mt-5">-->
<!--										<div class="mb-2"><b>{{ planName }}</b></div>-->
<!--										<div>Pay today: <span class="strike-through">${{ this.saveNow }}</span>-->
<!--											${{ this.payNow }} {{ this.currency }}/{{ this.payIntervalType }}<span-->
<!--												v-if="taxThen">*</span></div>-->
<!--										<div>Pay in 6 months: <span v-if="saveThen"-->
<!--																	class="strike-through">${{ this.saveThen }}</span>-->
<!--											${{ this.payThen }} {{ this.currency }}/{{ this.payIntervalType }}<span-->
<!--												v-if="taxThen">*</span></div>-->
<!--										<div class="text-muted mt-2">-->
<!--											<small>-->
<!--												<div v-if="taxThen">-->

<!--													<div>-->
<!--														*The prices above include Sales Tax.-->
<!--														<ToolTipView>-->
<!--															Depending on your country, the price can include a standard-->
<!--															tax called VAT which is regulated by the government of your-->
<!--															country.-->
<!--															<br/><br/>-->
<!--															If you are a registered businesses, you can enter your VAT-->
<!--															number below to remove the tax from the price.-->
<!--														</ToolTipView>-->
<!--													</div>-->

<!--													<div>Add your VAT number below to remove the Tax.</div>-->
<!--												</div>-->
<!--											</small>-->
<!--										</div>-->
<!--									</div>-->
<!--								</div>-->
<!--							</div>-->
<!--							&lt;!&ndash;							<div>&ndash;&gt;-->
<!--							&lt;!&ndash;								<el-button @click="testPaddleHook">Paddle Webhook</el-button>&ndash;&gt;-->
<!--							&lt;!&ndash;								<el-button @click="onPaymentSuccess">Payment success</el-button>&ndash;&gt;-->
<!--							&lt;!&ndash;								<el-button @click="testPaddleHookAndPaymentSuccess()">Both</el-button>&ndash;&gt;-->
<!--							&lt;!&ndash;							</div>&ndash;&gt;-->
<!--							<div class="checkout-container relative" style="padding-bottom: 150px;">-->

<!--								<div v-if="!isPaddleLoading" class="text-muted text-note absolute"-->
<!--									 style="bottom: 0; left: 0; right: 0; height: 370px; width:450px; background: white; padding: 1.3rem">-->
<!--									<span v-if="isSpecialTrial">By clicking "Subscribe Now", I agree to the Qwoach <a href="https://qwoach.com/terms" target="_blank">Terms of Use</a>, and give Qwoach permission to charge my credit card for ${{this.payThen}}{{this.currency}}/{{this.payIntervalType}}<span v-if="taxThen">*</span> after the 6 months trial is up.</span>-->
<!--									<span v-else>By clicking "Subscribe Now", I agree to the Qwoach <a href="https://qwoach.com/terms" target="_blank">Terms of Use</a>, and give Qwoach permission to charge my credit card for the discounted ${{this.payNow}}{{this.currency}}/{{this.payIntervalType}}<span v-if="taxThen">*</span> for the next 6 months and then special price of ${{this.payThen}}{{this.currency}}/{{this.payIntervalType}}<span v-if="taxThen">*</span> after the 6 months period is up.</span>-->
<!--									<div v-if="taxThen" class="mt-4">*Have a VAT number? Enter it above to remove the Sales Tax from the price.</div>-->

<!--									<div class="sc-bwzfXH bDcmNo my-5">-->
<!--										<div font-size="10px" class="sc-cSHVUG ktEtCx">This order process is conducted by our online reseller &amp; Merchant of Record Paddle.com.</div>-->
<!--										<div font-size="1.2em" class="sc-cSHVUG euKYoy">Your data will be shared with Qwoach LLC for product fullfillment. Paddle.com Market Ltd, Judd House, 18-29 Mora Street, London EC1V 8BT.</div>-->
<!--										<a font-size="1.2em" href="https://paddle.com/legal-buyers/" target="_blank" rel="noopener noreferrer" class="sc-gZMcBi biITmK">Paddle.com Terms &amp; Conditions</a> <span class="sc-eNQAEJ gIIoKl">|</span> <a font-size="1.2rem" href="https://paddle.com/privacy-buyers/" target="_blank" rel="noopener noreferrer" class="sc-gZMcBi biITmK">Paddle.com Privacy Policy</a>-->
<!--									</div>-->
<!--								</div>-->

<!--							</div>-->
<!--						</div>-->


<!--					</div>-->
				</div>

			</main><!-- /.main-content -->


		</div>
	</div>
</template>


<script>

import * as emailValidator from "email-validator"


import BaseComponent from "@/core/components/BaseComponent.vue";

export default {
	extends: BaseComponent,
	name: "RegisterSpecialInviteView",
	components: {},
	props: {
		isLoginCoach: Boolean,
		specialId: String,
	},
	watch:{
		specialId:{
			immediate: true,
			handler(){
				this.onSpecialIdChanged()
			}
		}
	},

	data() {
		return {
			location: {},
			stepNumber: 1,
			planId: 752045,
			currentForm: 'signup',
			isPaddleLoading: false,
			saveNow:"",
			saveThen:"",
			payNow:"",
			payThen:"",
			currency:"",
			payIntervalType:"",
			payIntervalLength:"",
			taxNow:0,
			taxThen:0,
			planName:"",

			form: {
				fullName: "",
				email: "",
				password: "",
				passwordConfirm: "",
				isTermsChecked: false
			},
			rules: {
				isTermsChecked: [
					{
						required: true,
						whitespace: false,
						validator: (rule, value, callback, source, options) => {
							let errorMsg = value ? undefined : "Please check terms"
							callback(errorMsg);
						},
						trigger: 'validate'
					},
				],


				fullName: [
					{
						required: true,
						whitespace: false,
						message: 'Please provide your name',
						trigger: 'validate'
					},
				],
				email: [
					{
						required: true,
						whitespace: false,
						validator: (rule, value, callback, source, options) => {
							let res = emailValidator.validate(this.form.email);
							let errorMsg = res ? undefined : "Please provide valid email address"
							callback(errorMsg);
						},
						trigger: 'validate'
					},
				],
				password: [
					{
						required: true,
						whitespace: false,
						validator: (rule, value, callback, source, options) => {
							let errorMsg;
							if (!this.form.password.length) {
								errorMsg = "Password is required"
							} else if (this.form.password.length < 6) {
								errorMsg = "Password is too short (6 characters minimum)"
							}
							callback(errorMsg);
						},
						trigger: 'validate'
					},
				],
				passwordConfirm: [
					{
						required: true,
						whitespace: false,
						validator: (rule, value, callback, source, options) => {
							let errorMsg;
							if (this.form.password !== this.form.passwordConfirm) {
								errorMsg = "Password and Confirm Password don't match"
							}
							callback(errorMsg);
						},
						trigger: 'validate'
					},
				],

			},

		}
	},

	mounted(){
		this.$analyticManager.setUserPropsOnce({first_contact: 'special_invite'})
		this.$analyticManager.setUserPropsOnce({initial_first_contact: 'special_invite'})
		this.$analyticManager.trackPageView({title:  "Register special invite page"})
	},

	computed: {

		loginLink() {
			return {
				name: this.isLoginCoach ? "LoginCoach" : "Login"
			}
		},

		isSpecialTrial() {
			return this.planId === 601237
		},
		isSpecialContributor() {
			return this.planId === 601238
		}

	},

	methods: {

		onSpecialIdChanged(){
			switch (this.specialId) {
				case "infostack":
					this.planId = 601237
					break;
				default:
					this.planId = Number(this.specialId || "") || 752045
			}
		},

		clearFormValidationInternal(){
			this.errorMessage = ""
			this.clearFormValidation()
		},

		async onFormValidated() {
			try {
				this.progressNonBlocking()
				if (await this.$dataManager.isUserExist(this.form.email)) {
					this.errorMessage = 'User with this email already exists. Please use different email.'
					this.hideProgress()
					return
				}
				this.location = await this.$dataManager.apiPostZip()
				this.performingRequest = false
				this.stepNumber = 2
				this.$nextTick(() => this.createAccount())
			} catch (error) {
				this.performingRequest = false
				this.handleError(error)
			}
			this.hideProgress()
		},



		async showPaddle() {
			this.isPaddleLoading = true
			document.removeEventListener("paddle_checkout_event", this.onPaddleEvent.bind(this));
			document.addEventListener("paddle_checkout_event", this.onPaddleEvent.bind(this));
			console.log("this.location = ", this.location)
			let amplitudeDeviceId = this.$analyticManager.getAmplitudeDeviceId()
			window.Paddle.Checkout.open({
				coupon: 'CORE_CONTRIBUTOR_SPECIAL_DISCOUNT',
				method: 'inline',
				frameTarget: 'checkout-container',
				frameInitialHeight: 416,
				frameStyle: 'width:450px; min-width:450px; background-color: white; border: none;',
				email: this.form.email,
				country: this.location.countryCode,
				postcode: this.location.zip,
				disableLogout: true,
				allowQuantity: false,
				product: this.planId,
				passthrough: {amplitudeDeviceId},
				successCallback: this.onPaymentSuccess.bind(this)
			})
		},

		onPaddleEvent(data) {
			data = data.detail
			this.isPaddleLoading = false
			console.log("onPaddleEvent: data2 = ", data)

			let firstPriceData = data.eventData.checkout.prices.customer
			let recurringPriceData = data.eventData.checkout.recurring_prices.customer
			let recurringPriceIntervalData = data.eventData.checkout.recurring_prices.interval
			let currency = firstPriceData.currency

			let taxFirst = Number(firstPriceData.total_tax);
			let totalFirst = Number(firstPriceData.total);
			let subtotalFirst = totalFirst - taxFirst
			subtotalFirst = subtotalFirst.toFixed(2)

			let totalThen = Number(recurringPriceData.total)
			let taxThen = Number(recurringPriceData.total_tax)
			let intervalTypeThen = recurringPriceIntervalData.type
			let intervalCountThen = Number(recurringPriceIntervalData.length)

			let taxPercentage = taxThen / (totalThen - taxThen)

			console.log("taxPercentage = ", taxPercentage)

			this.taxNow = taxFirst
			this.taxThen = taxThen
			this.currency = currency
			this.payNow = totalFirst
			this.payThenTotal = totalThen
			this.payThen = totalThen
			this.payThenTax = taxThen
			this.saveNow = this.payThen
			this.payIntervalType = intervalTypeThen
			this.payIntervalLength = intervalCountThen

			if(this.isSpecialTrial){
				this.planName = "Qwoach Essentials plan"
			} else {
				this.planName = "Get ALL features of Qwoach"
				this.saveNow = 89 + 89 * taxPercentage
				this.payThen = 19 + 19 * taxPercentage
				this.saveThen = this.saveNow
			}

		},


		async createAccount() {
			console.log("createAccount")
			this.progressBlocking("Setting up your account...\nPlease don't refresh this tab.")
			let profileData = this.createProfileData()
			try {
				await this.$dataManager.apiPostCreateCoachProfileSpecialFreeTrial(profileData)
				await this.$authManager.login(profileData.email, profileData.password)
				let _ = this.$analyticManager.trackEvent("User signed up", {campaign: "LinkedIn Campaign", campaign_title: "LinkedIn Feedback"})
				await this.go("CoachingProcessMainCoach")
			} catch (error) {
				this.hideProgress()
				this.handleError(error)
			}
		},

		createProfileData() {
			return {
				email: this.form.email,
				password: this.form.password,
				name: this.form.fullName,
				isRecoveryCoach: true,
				timezone: this.timezoneComputed,
			}
		},

	}
}
</script>

<style lang="scss">
//@import "../../../assets/scss/page";
/*@import "../../assets/css/page.css";*/
@import "login-view";


.register-view-root {
	.padding-x{
		padding: 0 13px;
	}
	.text-note {
		font-size: 12px;
	}

	.paddle-notice{
		position: fixed;
		bottom: 0;
		left: 0;
		right: 0;
	}

	.bDcmNo {
		font-size: 10px;
		background-color: rgb(255, 255, 255);
		height: auto;
		text-align: center;
		width: auto;
		border-width: 1px;
		border-style: solid;
		border-color: rgb(235, 236, 240);
		border-image: initial;
		border-radius: 4px;
		padding: 12px 16px 16px;
	}
	.ktEtCx {
		color: rgb(147, 147, 168);
		display: block;
		font-family: Lato, Helvetica, "Trebuchet MS", "Adobe Heiti Std", "Segoe UI", sans‑serif;
		font-size: 1.2em;
		/*font-weight: 400;*/
		line-height: 20px;
		margin-bottom: 8px;
		text-decoration: none;
	}
	.euKYoy {
		color: rgb(147, 147, 168);
		display: block;
		font-family: Lato, Helvetica, "Trebuchet MS", "Adobe Heiti Std", "Segoe UI", sans‑serif;
		font-size: 1.2em;
		/*font-weight: 400;*/
		line-height: 20px;
		margin-bottom: 8px;
		text-decoration: none;
	}
	.biITmK {
		color: rgb(6, 198, 104);
		display: inline;
		font-size: 1.2em;
		/*font-weight: 400;*/
		line-height: 2em;
		text-decoration: underline;
	}
}
</style>
